import React from "react";
import { Link } from "react-router-dom";
import {
  Breadcrumb,
  Card,
  Row,
  Col,
  Alert,
  Spin,
  Descriptions,
  Divider,
  Tag,
  Input,
  message,
} from "antd";
import {
  CarOutlined,
  SearchOutlined,
  ReloadOutlined,
  ArrowRightOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

import Config from "../../Config";
import { connect } from "react-redux";
import {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
  extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';
import { RoundedInput, RoundedButton } from "../../components/RoundedComponents";

const configClass = {
  title: "Informasi Kendaraan",
  apiUrl: {
    cari: "transaksi/api/info-pajak-kendaraan/cari/",
  },
  pageUrl: {
    info_pajak: "/admin/transaksi/informasi-penetapan-biaya",
  },
  breadCrumb: [
    <span>
      <CarOutlined /> Informasi
    </span>,
    "Informasi Kendaraan",
  ],
};

const config = new Config();

class FormInformasiKendaraan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errTitle: "",
      errMsg: "",

      cari_no_pol: undefined,
      loadingData: false,
      isOpenForm: false,
      dataKendaraan: null,
    };
  }

  UNSAFE_componentWillMount() {
    this.props.initHandler();
  }

  searchKendaraan = (no_polisi) => {
    if (!no_polisi || no_polisi.trim() === "") {
      message.warning("Masukkan nomor polisi terlebih dahulu");
      return;
    }

    this.setState({ loadingData: true, errTitle: "", errMsg: "", isOpenForm: false });

    message.loading({ content: "Mencari data kendaraan...", duration: 0, key: "toast" });

    this.props
      .ajaxViewHandler(
        "get",
        configClass.apiUrl.cari + "?nomor_polisi=KH" + no_polisi.toUpperCase()
      )
      .then((action) => {
        const { isSuccess, responseMsg: datas } = extractResult(action);
        // Reducer extracts response.results when present, so datas IS the vehicle object.
        // Error response {status: "Kendaraan Tidak Ditemukan", message: "..."} has no nomor_polisi.
        if (isSuccess) {
          if (datas?.nomor_polisi) {
            this.setState({
              isOpenForm: true,
              dataKendaraan: datas,
            });
            message.success({ content: "Data kendaraan ditemukan", duration: 2, key: "toast" });
          } else {
            this.setState({
              isOpenForm: false,
              dataKendaraan: null,
              errTitle: datas?.status || "Kendaraan Tidak Ditemukan",
              errMsg: datas?.message || "Pastikan nomor polisi sudah benar.",
            });
            message.error({ content: "Kendaraan tidak ditemukan", duration: 2, key: "toast" });
          }
        } else {
          this.setState({
            isOpenForm: false,
            dataKendaraan: null,
            errTitle: "Gagal mencari data",
            errMsg: JSON.stringify(datas),
          });
          message.error({ content: "Gagal mencari data kendaraan", duration: 2, key: "toast" });
        }
        this.setState({ loadingData: false });
      })
      .catch(() => {
        this.setState({ loadingData: false, isOpenForm: false });
        message.error({ content: "Gagal request data, coba lagi", duration: 2, key: "toast" });
      });
  };

  resetForm = () => {
    this.setState({
      cari_no_pol: undefined,
      isOpenForm: false,
      dataKendaraan: null,
      errTitle: "",
      errMsg: "",
    });
  };

  renderStatusBayar() {
    const { dataKendaraan } = this.state;
    if (!dataKendaraan?.status_bayar) return null;

    const { is_bayar, message: msg, selisih_hari } = dataKendaraan.status_bayar;

    if (is_bayar) {
      return (
        <Alert
          icon={<CheckCircleOutlined />}
          message="Dapat Melakukan Pembayaran"
          description={msg}
          type="success"
          showIcon
          style={{ marginBottom: 12 }}
        />
      );
    }
    if (selisih_hari < 0) {
      return (
        <Alert
          icon={<ExclamationCircleOutlined />}
          message="Lewat Jatuh Tempo"
          description={msg}
          type="error"
          showIcon
          style={{ marginBottom: 12 }}
        />
      );
    }
    return (
      <Alert
        icon={<ClockCircleOutlined />}
        message="Belum Dapat Dibayar"
        description={msg}
        type="info"
        showIcon
        style={{ marginBottom: 12 }}
      />
    );
  }

  renderTunggakan() {
    const { dataKendaraan } = this.state;
    if (!dataKendaraan?.tunggakan) return null;

    const { selisih_tahun, message: msg } = dataKendaraan.tunggakan;

    if (selisih_tahun > 0) {
      return (
        <Alert
          icon={<ExclamationCircleOutlined />}
          message={`Tunggakan ${selisih_tahun} Tahun`}
          description={msg}
          type="warning"
          showIcon
          style={{ marginBottom: 12 }}
        />
      );
    }
    return null;
  }

  renderInfoKendaraan() {
    const { dataKendaraan, cari_no_pol } = this.state;
    if (!dataKendaraan) return null;

    const nopolTengah = dataKendaraan.nomor_polisi_tengah || "";
    const nopolAkhir  = dataKendaraan.nomor_polisi_akhir  || "";
    const nopol = `KH ${nopolTengah} ${nopolAkhir}`.toUpperCase();

    return (
      <Spin spinning={this.state.loadingData}>
        <Card
          size="small"
          title={
            <span>
              <CarOutlined style={{ marginRight: 6 }} />
              Informasi Kendaraan
            </span>
          }
          style={{ marginTop: 16 }}
        >
          {this.renderStatusBayar()}
          {this.renderTunggakan()}

          <Descriptions
            bordered
            size="small"
            column={{ xs: 1, sm: 2, md: 2 }}
            style={{ marginBottom: 12 }}
          >
            <Descriptions.Item label="Nomor Polisi" span={2}>
              <Tag color="blue" style={{ fontSize: 14, padding: "2px 10px" }}>
                {nopol}
              </Tag>
            </Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ fontSize: 12 }}>
            Data Pemilik
          </Divider>
          <Descriptions
            bordered
            size="small"
            column={{ xs: 1, sm: 2, md: 2 }}
            style={{ marginBottom: 12 }}
          >
            <Descriptions.Item label="Nama Pemilik">
              {dataKendaraan.pemilik_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="NIK">
              {dataKendaraan.pemilik_nik || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Alamat" span={2}>
              {dataKendaraan.pemilik_alamat || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="No HP">
              {dataKendaraan.pemilik_no_hp || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Kepemilikan Ke">
              {dataKendaraan.kepemilikan_ke || "-"}
            </Descriptions.Item>
          </Descriptions>

          <Divider orientation="left" plain style={{ fontSize: 12 }}>
            Data Kendaraan
          </Divider>
          <Descriptions
            bordered
            size="small"
            column={{ xs: 1, sm: 2, md: 2 }}
          >
            <Descriptions.Item label="Merek">
              {dataKendaraan.merek_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Tipe">
              {dataKendaraan.tipe_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Jenis Kendaraan">
              {dataKendaraan.jenis_kendaraan_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Tahun Buat">
              {dataKendaraan.tahun_buat || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Silinder / CC">
              {dataKendaraan.silinder || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Bahan Bakar">
              {dataKendaraan.bahan_bakar_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Warna Kendaraan">
              {dataKendaraan.warna_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Warna Plat">
              {dataKendaraan.warna_plat_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Fungsi">
              {dataKendaraan.fungsi_nama || "-"}
            </Descriptions.Item>
            <Descriptions.Item label="Nomor Rangka">
              {dataKendaraan.nomor_rangka || "-"}
            </Descriptions.Item>
          </Descriptions>

          <Row justify="end" style={{ marginTop: 16 }} gutter={8}>
            <Col>
              <RoundedButton
                icon={<ReloadOutlined />}
                onClick={this.resetForm}
              >
                Cari Ulang
              </RoundedButton>
            </Col>
            <Col>
              <Link
                to={`${configClass.pageUrl.info_pajak}?no_pol=${encodeURIComponent(cari_no_pol || "")}`}
              >
                <RoundedButton
                  type="primary"
                  icon={<ArrowRightOutlined />}
                >
                  Lihat Informasi Pajak
                </RoundedButton>
              </Link>
            </Col>
          </Row>
        </Card>
      </Spin>
    );
  }

  render() {
    return (
      <>
        <div>
          <Helmet>
            <title>
              {configClass.title + " | " + config.get_site_info().name}
            </title>
          </Helmet>
          <div className="card" id="panel-transaksi">
            <Card className="konten" title={null}>

              {/* Error Alert */}
              <ErrorAlertModal
                visible={this.state.errTitle !== ''}
                title={this.state.errTitle}
                error={this.state.errMsg}
                onClose={() => this.setState({ errTitle: '', errMsg: '' })}
              />

              {/* Search Bar */}
              <Row>
                <Col span={24}>
                  <Input.Group compact>
                    <RoundedInput
                      height="28"
                      uppercase
                      autoFocus
                      allowClear
                      style={{ width: "calc(100% - 90px)" }}
                      placeholder="Input Nomor Polisi tanpa KH, cth : 1234XY"
                      prefix="KH"
                      value={this.state.cari_no_pol}
                      size="large"
                      onChange={(e) => {
                        const raw = e.target.value;
                        const regex = /^\d+\.?\d*$/;
                        let startIdx = 0;
                        if (!regex.test(raw.charAt(0))) {
                          if (!regex.test(raw.charAt(1))) {
                            startIdx = 2;
                          } else {
                            startIdx = 1;
                          }
                        }
                        const noKendaraan = raw.substring(startIdx).toUpperCase();
                        this.setState({ cari_no_pol: noKendaraan });
                      }}
                      onKeyPress={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          this.searchKendaraan(this.state.cari_no_pol);
                        }
                      }}
                    />
                    <RoundedButton
                      type="primary"
                      size="large"
                      style={{ width: 90 }}
                      loading={this.state.loadingData}
                      icon={<SearchOutlined />}
                      onClick={() => this.searchKendaraan(this.state.cari_no_pol)}
                    >
                      Cari
                    </RoundedButton>
                  </Input.Group>
                </Col>
              </Row>

              {/* Info Kendaraan */}
              {this.state.isOpenForm && this.renderInfoKendaraan()}

            </Card>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = function (state) {
  return state.configReducers;
};

export default connect(mapStateToProps, {
  initHandler,
  ajaxViewHandler,
  ajaxHandler,
  setConfig,
})(FormInformasiKendaraan);
